'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { AvatarRootContext } from './context/avatar-root.context';
import { useGetInitials } from './hooks/use-get-initials';
import type { AvatarFullNamePropsInterface } from './types/avatar-full-name.types';

/**
 * @since 10.0.0
 */
export const AvatarFullName = forwardRef<HTMLDivElement, AvatarFullNamePropsInterface>(
  (props, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;

    const fullInitials = useGetInitials(children);
    const singleInitial = useGetInitials(children, true);

    const { size = 'lg' } = useContext(AvatarRootContext);
    const displayInitials = ['xs', 'sm', 'md'].includes(size) ? singleInitial : fullInitials;

    const styles = css(cssProp);

    return (
      <div
        data-c11n-component="Avatar.FullName"
        data-c11n-version={__C11N_VERSION__}
        ref={forwardedRef}
        className={cx('c11n', 'c11n_avatar__full-name', styles, className)}
        {...rest}
      >
        {displayInitials}
      </div>
    );
  },
);

AvatarFullName.displayName = 'Avatar.FullName';
